// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';

// ** Toast Import
import { toast } from 'react-toastify';

const headers = {
    'Content-Type': 'application/json'
};

export const getODRemoteWork = createAsyncThunk('ODRemoteWorkSlice/getODRemoteWork', async () => {
    try {
        const response = await axios.get('/ODRemoteWorkRule', { headers });
        return Promise.resolve(response?.data);
    } catch (error) {
        console.log('error', error);
        toast.error(error?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(error);
    }
});

export const getODRemoteWorkById = createAsyncThunk('ODRemoteWorkSlice/getODRemoteWorkById', async (id) => {
    try {
        const response = await axios.get('/ODRemoteWorkRule/' + id, { headers });
        return Promise.resolve(response?.data);
    } catch (error) {
        console.log('error', error);
        toast.error(error?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(error);
    }
});

export const createODRemoteWork = createAsyncThunk(
    'ODRemoteWorkSlice/createODRemoteWork',
    async (data, { dispatch }) => {
        try {
            const response = await axios.post('/ODRemoteWorkRule', data, { headers });
            toast.success(response?.data?.message || 'OD & Remote Work rule added successfully.');
            await dispatch(getODRemoteWork());
            return Promise.resolve(response);
        } catch (error) {
            console.log('error', error);
            toast.error(error?.response?.data?.message || 'Something went wrong!');
            return Promise.reject(error);
        }
    }
);

export const updateODRemoteWork = createAsyncThunk(
    'ODRemoteWorkSlice/updateODRemoteWork',
    async (data, { dispatch }) => {
        try {
            const response = await axios.put('/ODRemoteWorkRule/' + data?.id, data?.data, { headers });
            toast.success(response?.data?.message || 'OD & Remote Work rule updated successfully.');
            await dispatch(getODRemoteWork());
            return Promise.resolve(response);
        } catch (error) {
            console.log('error', error);
            toast.error(error?.response?.data?.message || 'Something went wrong!');
            return Promise.reject(error);
        }
    }
);

export const deleteODRemoteWork = createAsyncThunk(
    'ODRemoteWorkSlice/deleteODRemoteWork',
    async (id, { dispatch }) => {
        try {
            const response = await axios.delete('/ODRemoteWorkRule/' + id, { headers });
            toast.success(response?.data?.message || 'OD & Remote Work rule deleted successfully.');
            await dispatch(getODRemoteWork());
            return Promise.resolve(response);
        } catch (error) {
            console.log('error', error);
            toast.error(error?.response?.data?.message || 'Something went wrong!');
            return Promise.reject(error);
        }
    }
);

export const updateODRemoteWorkStatus = createAsyncThunk(
    'ODRemoteWorkSlice/updateODRemoteWorkStatus',
    async (id, { dispatch }) => {
        try {
            const response = await axios.put('/ODRemoteWorkRule/status/' + id, {}, { headers });
            toast.success(response?.data?.message || 'Status updated successfully.');
            await dispatch(getODRemoteWork());
            return Promise.resolve(response);
        } catch (error) {
            console.log('error', error);
            toast.error(error?.response?.data?.message || 'Something went wrong!');
            return Promise.reject(error);
        }
    }
);

export const getEmployee = createAsyncThunk('ODRemoteWorkSlice/getEmployee', async () => {
    try {
        const response = await axios.get('/Employee', { headers });
        return Promise.resolve(response?.data);
    } catch (error) {
        console.log('error', error);
        toast.error(error?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(error);
    }
});

export const bulkAssignODRemoteWork = createAsyncThunk(
    'ODRemoteWorkSlice/bulkAssignODRemoteWork',
    async (data, { dispatch }) => {
        try {
            const response = await axios.post('/ODRemoteWorkRule/assign-od-remote-work-rule', data, { headers });
            toast.success(response?.data?.message || 'OD & Remote Work rule assigned successfully.');
            await dispatch(getODRemoteWork());
            return Promise.resolve(response);
        } catch (error) {
            console.log('error', error);
            toast.error(error?.response?.data?.message || 'Something went wrong!');
            return Promise.reject(error);
        }
    }
);

export const getAssignedODRemoteWorkEmployees = createAsyncThunk(
    'ODRemoteWorkSlice/getAssignedODRemoteWorkEmployees',
    async (id) => {
        try {
            const response = await axios.get('/ODRemoteWorkRule/assigned-employee/' + id, { headers });
            return Promise.resolve(response?.data);
        } catch (error) {
            console.log('error', error);
            toast.error(error?.response?.data?.message || 'Something went wrong!');
            return Promise.reject(error);
        }
    }
);

export const getApprovalChainOptions = createAsyncThunk(
    'ODRemoteWorkSlice/getApprovalChainOptions',
    async () => {
        try {
            const response = await axios.get('/ODRemoteWorkRule/approval-chain-options', { headers });
            return Promise.resolve(response?.data);
        } catch (error) {
            console.log('error', error);
            toast.error(error?.response?.data?.message || 'Something went wrong!');
            return Promise.reject(error);
        }
    }
);

// ** Aliases used by Form.js
export const createODPolicy = createODRemoteWork;
export const updateODPolicy = updateODRemoteWork;
export const getODPolicyById = getODRemoteWorkById;

export const ODRemoteWorkSlice = createSlice({
    name: 'ODRemoteWorkSlice',
    initialState: {
        ODRemoteWorkRules: [],
        odPolicyDetail: null,
        approvalChainOptions: [],
        employeeList: []
    },
    extraReducers: (builder) => {
        builder.addCase(getODRemoteWork.fulfilled, (state, action) => {
            state.ODRemoteWorkRules = action?.payload;
        });
        builder.addCase(getODRemoteWorkById.fulfilled, (state, action) => {
            state.odPolicyDetail = action?.payload;
        });
        builder.addCase(getApprovalChainOptions.fulfilled, (state, action) => {
            state.approvalChainOptions = action?.payload;
        });
        builder.addCase(getEmployee.fulfilled, (state, action) => {
            state.employeeList = action?.payload;
        });
    }
});

export default ODRemoteWorkSlice.reducer;
